import axios from "axios";

let baseAxios,
  customAxios = false;
try {
  // @ts-ignore
  customAxios = require("../../src/api/BaseApi");
  if ((customAxios as any).baseAxios) {
    customAxios = (customAxios as any).baseAxios;
  } else {
    console.log("invalid baseAxios", customAxios);
    customAxios = false;
  }
} catch (e) {
  console.log(e);
}

if (customAxios) {
  baseAxios = customAxios;
} else {
  // import {formErrorInterceptor, standardErrorInterceptor} from './interceptors';

  let baseURL = "/";
  if (
    (window as any).appConfig &&
    (window as any).appConfig.serverContextPath
  ) {
    baseURL = (window as any).appConfig.serverContextPath;
  } else if ((window as any).serverContextPath) {
    baseURL = (window as any).serverContextPath;
  }

  baseAxios = axios.create({
    baseURL,
    headers: { Pragma: "no-cache" },
  });

  // Add a response interceptor
  // baseAxios.interceptors.response.use(null, standardErrorInterceptor());
}

export { baseAxios };
